export default __webpack_public_path__ + "static/media/6baddie.0923559b.mp3";